//#region Libraries
//#endregion
//#region Styles
import { Column, Row, TitleSection } from "components/styles";
//#endregion
//#region Components
import PageManager from "components/PageManager/PageManager";
import Filters from "./components/Filters/Filters";
//#endregion
//#region Images
//#endregion
//#region Services
//#endregion
//#region Utils
//#endregion

const HeaderRoles = ({
    filterFields,
    paginator,
    setTriggerRequest,
    data,
    clearNewlyAddedOrUpdatedUser,
    searchedFilters
}) => {
    const doSetTriggerRequest = value => {
        clearNewlyAddedOrUpdatedUser();
        setTriggerRequest(value);
    }
    return (
        <Column marginTop="10px">
            <SuperHeader 
                paginator={paginator} 
                setTriggerRequest={doSetTriggerRequest}
                clearNewlyAddedOrUpdatedUser={clearNewlyAddedOrUpdatedUser}
                searchedFilters={searchedFilters}/>
            <Filters 
                filterFields={filterFields}
                data={data}
                movePage={paginator.movePage}
                setTriggerRequest={doSetTriggerRequest}/>
        </Column>
    );
}

const SuperHeader = ({
    paginator,
    setTriggerRequest,
    searchedFilters
}) => {
    return (
        <Row width="100%">
            <TitleSection>Roles</TitleSection>
            <PageManager 
                caption="Roles"
                dataPaginator={{
                    currentPage: searchedFilters.page,
                    quantityPages: paginator.data.quantityPages,
                    setCurrentPage: page => {
                        paginator.movePage(page);
                        setTriggerRequest(true);
                    }
                }}/>
        </Row>
    );
}

export default HeaderRoles;